

export class AnimatedNumber
{

	constructor(private element: HTMLElement, private startingValue: number, private endValue: number, private speed: number = 2000) {
		this.animate(this.element);
	}
	

	animate(elem: HTMLElement) {
		let current = Math.max(1, this.endValue - 500);
		const end = this.endValue;
		
		const timeIntervalBeforeIncrement = this.speed / this.endValue;
		
		const interval = setInterval(() => {
			elem.innerHTML = (current++).toString();
			if (current > end) {
				clearInterval(interval);
			}
		}, timeIntervalBeforeIncrement);
		
	}

}